module.exports = __webpack_public_path__ + "img/logo_home.c32b2103.png";